import ProjectAudit from './src/main';

/* istanbul ignore next */
ProjectAudit.install = function(Vue) {
  Vue.component(ProjectAudit.name, ProjectAudit);
};

export default ProjectAudit;
